<template>
  <el-tabs v-model="activeTabName" class="device-detail-tabs">
    <!--    v-if="shadowRole"-->
    <!--    :roleList="shadowRoleList"-->
    <el-tab-pane :label="$t('APPUser.deviceList')" name="first" lazy>
      <Device v-if="activeTabName === 'first'" :tableData="tableData" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { getRoleByOperationCode, getRoute } from '@/authorized'
import Device from './Device'
export default {
  name: 'index',
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Device
  },
  created() {
    // if (this.shadowRole) {
    //   this.activeTabName = 'first'
    // } else if (this.historyRole) {
    //   this.activeTabName = 'second'
    // } else if (this.onlineRole) {
    //   this.activeTabName = 'third'
    // } else if (this.warningRole) {
    //   this.activeTabName = 'fourth'
    // } else if (this.faultRole) {
    //   this.activeTabName = 'fiveth'
    // } else if (this.userRole) {
    //   this.activeTabName = 'sixth'
    // }
  },
  data() {
    return {
      activeTabName: 'first'
    }
  },
  computed: {
    // detailRoleList() {
    //   let path = '/device/list'.toLowerCase()
    //   let productModelRole = getRoute(path, this.$store.state.menus) || {}
    //   let detailRole = getRoleByOperationCode(productModelRole.childList, 'detail')
    //   return detailRole && detailRole.isPermission === 'Y' ? detailRole.childList : []
    // },
    // // 设备影子
    // shadowRole() {
    //   let role = getRoleByOperationCode(this.detailRoleList, 'shadow')
    //   if (role) {
    //     let val = getRoleByOperationCode(role.childList, 'query')
    //     return val ? val.isPermission == 'Y' : false
    //   }
    //   return false
    // },
    // shadowRoleList() {
    //   let role = getRoleByOperationCode(this.detailRoleList, 'shadow')
    //   return role && role.isPermission === 'Y' ? role.childList : []
    // },
  }
}
</script>

<style scoped></style>
